"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _ArrowDropUp = _interopRequireDefault(require("@material-ui/icons/ArrowDropUp"));
var _SttHeading = _interopRequireDefault(require("../SttTypography/SttHeading"));
var _SttCollapse = _interopRequireDefault(require("../SttCollapse"));
var _core = require("@material-ui/core");
var _excluded = ["title", "children", "opened", "compact", "classegriditem", "callback"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _icon;
  return {
    content: function content(props) {
      return _defineProperty({
        paddingBottom: !props.compact && theme.spacing(1)
      }, theme.breakpoints.up('md'), {
        paddingTop: !props.compact && theme.spacing(2),
        paddingLeft: !props.compact && theme.spacing(2)
      });
    },
    title: function title(props) {
      return _defineProperty({
        cursor: 'pointer',
        paddingBottom: !props.compact && theme.spacing(1),
        paddingRight: !props.compact && theme.spacing(2)
      }, theme.breakpoints.up('md'), {
        paddingTop: !props.compact && theme.spacing(2),
        position: !props.compact && 'relative'
      });
    },
    icon: (_icon = {
      position: 'absolute',
      marginLeft: theme.spacing(2)
    }, _defineProperty(_icon, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(4)
    }), _defineProperty(_icon, "marginTop", theme.spacing(1)), _icon)
  };
});
function SttExpansionPanel(props) {
  var classes = useStyles(props);
  var title = props.title,
    children = props.children,
    _props$opened = props.opened,
    opened = _props$opened === void 0 ? true : _props$opened,
    _props$compact = props.compact,
    compact = _props$compact === void 0 ? false : _props$compact,
    _props$classegriditem = props.classegriditem,
    classegriditem = _props$classegriditem === void 0 ? '' : _props$classegriditem,
    callback = props.callback,
    other = _objectWithoutProperties(props, _excluded);
  var _React$useState = _react["default"].useState(opened),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _React$useState3 = _react["default"].useState([3, 9]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    bigScreenColumn = _React$useState4[0],
    setBigScreenColumns = _React$useState4[1];
  _react["default"].useEffect(function () {
    setOpen(opened);
  }, [opened]);
  _react["default"].useEffect(function () {
    if (compact) {
      setBigScreenColumns([12, 12]);
    }
  }, [compact]);
  var handleClick = function handleClick() {
    var novoEstado = !open;
    setOpen(novoEstado);
    if (callback) {
      callback(novoEstado);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    sm: 12,
    md: bigScreenColumn[0]
  }, /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
    variant: "h3",
    color: "primary",
    className: classes.title,
    onClick: handleClick
  }, title, open ? /*#__PURE__*/_react["default"].createElement(_ArrowDropUp["default"], {
    className: classes.icon
  }) : /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], {
    className: classes.icon
  }))), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    sm: 12,
    md: bigScreenColumn[1],
    className: classegriditem
  }, /*#__PURE__*/_react["default"].createElement(_SttCollapse["default"], _extends({
    "in": open
  }, other, {
    className: classes.content
  }), children)));
}
var _default = SttExpansionPanel;
exports["default"] = _default;